module.exports = __webpack_public_path__ + "img/1-4.6cd17c95.jpg";